export const BREADCRUMB_DOCUMENTS = [
    {
        label: "breadcrumb.home",
        href: "/",
    },
    {
        label: "breadcrumb.hr_documents",
        href: "/rh/documents",
    },
];

export const BREADCRUMB_HUMBERGER = [
    {
        id: 1,
        name: "Accueil",
        link: "/",
    },
    {
        id: 2,
        name: "Mes tâches",
        link: "/tasks",
    },
    {
        id: 3,
        name: "Gestion du temps",
        link: "/manage_time",
    },
];

export const I18N_NS_DOCUMENTS = "hr_documents";

export const DOCUMENT_TYPE_HR = {
    hr: "hr",
    leave: "leave",
    expense_report: "expense_report",
    timesheet: "timesheet",
    common: "hr",
};
